import React, {useState} from 'react'
import styled from 'styled-components'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import BCText from './BigCenteredText'
import Carousel from 'react-bootstrap/Carousel'

const ItemWrapper = styled.div`
    padding: 30px;
    width: 30%;
    margin: 2vw auto 5vh;
    @media screen and (max-width: 1000px) {
        width: 90%;
    }
`


const CenteredTextRow = ({props}) => {

    var items
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    if (props.length < 4){
        items = props.map((item) => {
            return (
                <Col key={item.id}>
                <BCText props={item}/>
                </Col>
            )
        })
        return (
            <div>
                <Container>
                    <Row>
                        {items}
                    </Row>
                </Container>
            </div>
        )
    } else {
        items = props.map((item) => {
            return (
            <Carousel.Item key={item.id}>
            <ItemWrapper>
            <BCText props={item} />
            </ItemWrapper>
            </Carousel.Item>
        )})
        return (
            <Carousel activeIndex={index} onSelect={handleSelect}>
            {items}
            </Carousel>
        )
    }


    
}

export default CenteredTextRow
